import apiClient from './apiService'

export default {
  getUnread() {
    return apiClient.get('/creative-upload-alerts')
  },

  markRead(id) {
    return apiClient.patch(`/creative-upload-alerts/${id}/read`)
  },
}
